import { render, staticRenderFns } from "./ArticleModal.vue?vue&type=template&id=c842f4ee&scoped=true"
import script from "./ArticleModal.vue?vue&type=script&lang=js"
export * from "./ArticleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c842f4ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c842f4ee')) {
      api.createRecord('c842f4ee', component.options)
    } else {
      api.reload('c842f4ee', component.options)
    }
    module.hot.accept("./ArticleModal.vue?vue&type=template&id=c842f4ee&scoped=true", function () {
      api.rerender('c842f4ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/article/modules/ArticleModal.vue"
export default component.exports